export const parseInteger = (intString) => {
  return parseInt(intString, 10);
};